import * as React from 'react';
import { CommandItem } from './types';
import CommandBarItem from './CommandBarItem';

type Props = {
  title: string;
  items: CommandItem[];
  selectedIndex: number;
  baseIndex: number;
  onSelect: (item: CommandItem) => void;
};

const CommandBarSection: React.FC<Props> = ({
  title,
  items,
  selectedIndex,
  baseIndex,
  onSelect,
}) => {
  return (
    <div className="command-bar-section" role="group" aria-label={title}>
      <div className="command-bar-section-title">{title}</div>
      {items.map((item, i) => (
        <CommandBarItem
          key={item.id}
          item={item}
          isSelected={selectedIndex === baseIndex + i}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};

export default CommandBarSection;
